import React from 'react';
import { KEYS_CHARCODE } from 'wix-rich-content-editor-common';
import { FocusManager } from 'wix-rich-content-ui-components';
import { s as styles } from '../audio.rtlignore-f8be5668.js';
import '../style-inject.es-e7b07dd7.js';

const optionElement = (option) => {
  const selected = option == null ? void 0 : option.selected;
  const content = option.icon ? /* @__PURE__ */ React.createElement("span", { className: styles.dropdown_content_withIcon }, option.icon(), option.text) : /* @__PURE__ */ React.createElement("span", { className: styles.dropdown_content }, option.text);
  const onKeyDown = (e) => {
    if (e.keyCode === KEYS_CHARCODE.ENTER) {
      option.onClick();
    }
  };
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      key: option.text,
      className: selected ? styles.dropdown_selected_button : "",
      onKeyDown,
      onClick: option.onClick,
      "data-hook": option == null ? void 0 : option.dataHook,
      type: "button"
    },
    content
  );
};
const DropdownMenu = ({ options, onClose }) => {
  const onKeyDown = (e) => {
    if (e.keyCode === KEYS_CHARCODE.ESCAPE) {
      onClose();
    }
  };
  return /* @__PURE__ */ React.createElement(FocusManager, { onKeyDown }, /* @__PURE__ */ React.createElement("div", { className: styles.dropdown_menu_wrapper }, options.map((option) => optionElement(option))));
};

export { DropdownMenu as default };
//# sourceMappingURL=DropdownMenu.js.map
